module.exports = "<ngx-loading-bar></ngx-loading-bar>\r\n\r\n<router-outlet></router-outlet>\r\n"